import React from 'react';
import { MapPinIcon, StarIcon, CheckCircleIcon, ChevronRightIcon } from 'lucide-react';
import { School } from '../data/schools';
interface SchoolListingCardProps {
  school: School;
  onSelect?: (schoolId: string) => void;
}
export function SchoolListingCard({
  school,
  onSelect
}: SchoolListingCardProps) {
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200 flex flex-col md:flex-row" data-id="element-780" data-mp="3c6igq9bdezhy">
      {/* Left side: Logo placeholder & basic info */}
      <div className="md:w-1/3 bg-light p-6 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-gray-200 relative" data-id="element-781" data-mp="2kfuhj2t9c46x">
        {school.featured && <div className="absolute top-0 left-0 bg-gold text-white text-xs font-bold px-3 py-1 rounded-br-lg uppercase tracking-wider" data-id="element-782" data-mp="2tept6uf2m6hm">
            Featured
          </div>}
        <div className="w-24 h-24 bg-white rounded-full shadow-sm flex items-center justify-center mb-4 border border-gray-100" data-id="element-783" data-mp="20qk45vgzhvbz">
          <span className="text-2xl font-bold text-navy text-center leading-none" data-id="element-784" data-mp="63h2c2ssdhvl">
            {school.name.split(' ').map(w => w[0]).join('').substring(0, 2)}
          </span>
        </div>
        <h3 className="text-lg font-bold text-navy text-center mb-2" data-id="element-785" data-mp="fu1y7ih2s8at">
          {school.name}
        </h3>
        <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-786" data-mp="ksd5pmjwe6pv">
          <MapPinIcon className="w-4 h-4 mr-1" data-id="element-787" data-mp="3jbadbukf4u1u" />
          {school.location}
        </div>
        <div className="flex items-center text-gold" data-id="element-788" data-mp="3oa3tjur3az5p">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < Math.floor(school.rating) ? 'fill-current' : 'text-gray-300'}`} data-id="element-789" data-mp="3obye37yg8p99" data-mpi={i} />)}
          <span className="text-xs text-gray-600 ml-1 font-medium" data-id="element-790" data-mp="155svt6el9dw">
            {school.rating}
          </span>
        </div>
      </div>

      {/* Right side: Details & CTA */}
      <div className="md:w-2/3 p-6 flex flex-col" data-id="element-791" data-mp="18lbszj89zn98">
        <div className="flex-grow" data-id="element-792" data-mp="1cjjdmp5v18pp">
          <div className="flex items-center mb-3" data-id="element-793" data-mp="1cmnlpxmg4oln">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-794" data-mp="39kfen33eafrl">
              <CheckCircleIcon className="w-3 h-3 mr-1" data-id="element-795" data-mp="34ludn1gbjs23" />
              {school.accreditation}
            </span>
            {school.onlineOnly && <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-796" data-mp="3dmshnjqrbzko">
                100% Online
              </span>}
          </div>

          <p className="text-sm text-gray-600 mb-4 line-clamp-3" data-id="element-797" data-mp="2lvmhx4ey83vx">
            {school.description}
          </p>

          <div className="mb-4" data-id="element-798" data-mp="2znkigqulgrgh">
            <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-2" data-id="element-799" data-mp="2znsuyhmt1ur5">
              Popular Programs:
            </h4>
            <div className="flex flex-wrap gap-2" data-id="element-800" data-mp="276qan9kpuuwd">
              {school.programsOffered.slice(0, 4).map((program, idx) => <span key={idx} className="text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded" data-id="element-801" data-mp="227wtn7680lrg" data-mpi={idx}>
                  {program}
                </span>)}
              {school.programsOffered.length > 4 && <span className="text-xs text-gray-500 px-2 py-1" data-id="element-802" data-mp="mgb34x855yqh">
                  +{school.programsOffered.length - 4} more
                </span>}
            </div>
          </div>
        </div>

        <div className="mt-auto pt-4 border-t border-gray-100 flex justify-end" data-id="element-803" data-mp="8n3bx6nz359b">
          <button onClick={() => onSelect && onSelect(school.id)} className="inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-semibold rounded-md text-white bg-cta hover:bg-cta-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cta-dark transition-colors duration-200" data-id="element-804" data-mp="do98xgoo1eon">
            Request Info
            <ChevronRightIcon className="ml-2 -mr-1 w-4 h-4" data-id="element-805" data-mp="wdpietibwhh7" />
          </button>
        </div>
      </div>
    </div>;
}